import { ChoiceFieldProps, classNames, useFormField } from "zeta-dom-react";
import { validators } from ".";

export interface RadioListItem<T = string> {
    value: T;
    label: string;
}

export interface RadioListProps<T = string> extends ChoiceFieldProps<RadioListItem<T>> {
    className?: string;
    required?: boolean;
    variant?: 'outlined';
    orientation?: 'horizontal' | 'vertical';
    showErrorMessage?: boolean;
}

export function RadioList<T = string>(props: RadioListProps<T>) {
    props = {
        ...props,
        onValidate: validators.combine<T | ''>(
            props.required && validators.required(),
            props.onValidate
        )
    };
    const { value, error, setValue, elementRef, items } = useFormField('choice', props, '');

    return (
        <div ref={elementRef} className={classNames('eac-field eac-radio-list', props.className, { 'has-error': !!error, variant: props.variant, orientation: props.orientation })}>
            {items.map((v, i) => (
                <label key={i} className={classNames({ checked: v.value === value })}>
                    <input name={props.name} type="radio" checked={v.value === value} onChange={() => setValue(v.value)} />
                    <span>{v.label}</span>
                </label>
            ))}
            {error && props.showErrorMessage !== false &&
                <div className="eac-field-error">{error}</div>}
        </div>
    );
}
